import { ReactNode } from 'react'

type Result = ReactNode
export function renderText(text: string) {
  const regex = text.match(
    // eslint-disable-next-line
    /(https?|file):\/\/[a-zA-Z0-9\/:%#&~=_!'\$\?\(\)\.\+\*\-]+|(^|\n)\\\\[^<>{}"`|\^\[\]\r\n]+/g
  )
  if (!regex) {
    return text
  }
  let results: Result[] = [text]
  regex.forEach((url, idx) => {
    if (url[0] === '\n') url = url.substring(1)

    let href = url
    if (/^\\\\/.test(url)) {
      href = 'file:' + encodeURI(url.replace(/\\/g, '/'))
    }

    const target = results.pop()
    if (target && typeof target === 'string') {
      const items = target.split(url)
      results = [
        ...results,
        items[0],
        <a href={href} key={idx} target="_blank" rel="noopener noreferrer">
          {url}
        </a>,
        items.slice(1).join(url),
      ].filter(e => !!e)
    }
  })

  return results
}
